/** 
* @description 数据管理的基础库 跨框架使用的 数据管理获取 
* @version 0.3.1 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
import _pick from 'lodash/pick';
import _assign from 'lodash/assign';
import { __spreadArray } from 'tslib';
import { Log } from '../helpers';
import { BasesOptions } from './basesOptions';

var BasesUtils =
/** @class */
function () {
  function BasesUtils() {} // static request<T>(options?: string | IAjaxConfig | ((ctr: T) => IAjaxConfig)) {
  //     return function (target: T, propertyKey: string, descriptor: PropertyDescriptor) {
  //         const value = descriptor.value;
  //         descriptor.value = async function () {
  //             return AjaxBasics.request(lodash.merge({  }, ))
  //         }
  //         // descriptor.enumerable = value;
  //     };
  // }


  BasesUtils.getDetailsOptions = function (options) {
    return _assign({}, _pick(options, ['target', 'dataKey', 'details', 'detailsParams', 'entityModel']), options.DetailsOptions);
  };

  BasesUtils.getPaginationOptions = function (options) {
    return _assign({}, _pick(options, ['target', 'dataKey', 'pagination', 'infinite', 'paginationParams', 'listModel']), options.PaginationOptions);
  };

  BasesUtils.log = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    if (!BasesOptions.debug) return true;
    Log.info.apply(Log, __spreadArray(["\u3010Base\u3011 " + message], optionalParams));
    return true;
  };

  BasesUtils.warning = function (message) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    if (!BasesOptions.debug) return true;
    Log.warning.apply(Log, __spreadArray(["\u3010Base\u3011 " + message], optionalParams));
    return true;
  };

  BasesUtils.error = function (obsKey) {
    var optionalParams = [];

    for (var _i = 1; _i < arguments.length; _i++) {
      optionalParams[_i - 1] = arguments[_i];
    }

    if (!BasesOptions.debug) return true;
    Log.error.apply(Log, __spreadArray(["\u3010Base\u3011 " + obsKey], optionalParams));
    return true;
  };

  return BasesUtils;
}();

export { BasesUtils };
//# sourceMappingURL=basesUtils.js.map
